<template>
  <a v-editable="blok" :href="getLinkFieldUrl(url)" :class="['btn', 'btn-' + blok.theme, !hasIconName && blok.icon && `btn-icon-${blok.icon}`, hasIconName && `btn-has-icon`, blok?.isUnderlined && `btn-underlined`]" :aria-label="label" :target="url?.target" role="button" @click="onClick">{{ label }} <UIcon v-if="hasIconName && blok.iconName" :name="blok.iconName" class="btn-icon" /> </a>
</template>

<script setup lang="ts">
  import { getLinkFieldUrl } from "#imports";
  import type { ButtonStoryblok, MultilinkStoryblok } from "~/types/storyblok";
  const props = defineProps<{ blok: ButtonStoryblok }>();

  const hasIconName = computed(() => props.blok.iconName && props.blok.iconName.length > 0);

  const onClick = (event: Event) => {
    const link = getLinkFieldUrl(url.value);
    if (link && link.startsWith("#")) {
      const target = document.querySelector(link);
      if (target) {
        event.preventDefault();
        target.scrollIntoView({ behavior: "smooth" });
      }
    }
  };
  
  const label = computed(() => {
    return props.blok.label;
  });

  const url = computed<MultilinkStoryblok>(() => {
    return props.blok.url;
  });
</script>
